export default __webpack_public_path__ + "static/media/clinic7.10d94e2e.jpg";